import type { ReactElement } from 'react';

import { useConfigSlice } from '../../../store/slices/config/selectors';
import { redirectParentIframe } from '../../../utils/redirect';
import { ButtonVariant } from '../../controls/button/Button';
import { Curtain } from '../../curtain/Curtain';
import { BlockingModalContent } from '../content/BlockingModalContent';
import { Popup } from '../Popup';

export const SessionExpiredConnected = (): ReactElement | null => {
  const casinoConfig = useConfigSlice.casinoConfig();

  const homeUrl = casinoConfig?.homeUrl;
  Curtain.remove();
  const actions = homeUrl
    ? [
        {
          tk: 'OK',
          type: ButtonVariant.MAIN,
          click: (): void => {
            redirectParentIframe(homeUrl);
          },
        },
      ]
    : [];

  return <BlockingModalContent titleTk="PP_7" messageTk="ERROR_2400" actions={actions} />;
};

export const SessionExpiredPopupConnected = (): ReactElement | null => {
  const session = useConfigSlice.session();
  if (session !== null) return null;

  return (
    <Popup
      content={<BlockingModalContent titleTk="PP_7" messageTk="ERROR_2400" />}
      handleClose={(): void => {}}
      headerLess
    />
  );
};
